import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { SubAccountSelector } from './subAccountSelector';
import { OneCard } from '../analysisEmployeeChart/oneCard';
import { RPCFactory } from '../../../utils/RequestUtil';
import { getSubaccountFromLocalStorage } from './util';
import { isSubAccount } from '../../../consts/multiAccountConfig';

export const TotalUploadAnalysis = (props) => {
  const startDate = moment().subtract(14, 'days').format('YYYY-MM-DD');
  const endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
  const [queryAccountId, setQueryAccountId] = useState(getSubaccountFromLocalStorage() || window.pageProps.uid);
  const [actionSubTypes, setLeadsType] = useState([]);
  const [trendData, setTrendData] = useState({
    effectiveLeadsReportTrendData: {
    total: 0,
    totalLastPeriod: 0,
    entities: []
    },
    leadsTrendData: {
      total: 0,
      totalLastPeriod: 0,
      entities: []
    }
  });
  const [uploadStatistic, setStatistic] = useState({});
  useEffect(() => {
    const param = { startDate, endDate, queryAccountId, ... (actionSubTypes.length ? { actionSubTypes } : {}) };
    RPCFactory.DMPUpload.getDmpUploadOverview(param)
      .done((data) => {
        setTrendData(data);
        // setTrendData(trendDataInit);
      })
      .fail((ret, msg) => {
        alert(msg);
      });

    RPCFactory.DMPUpload.getDmpUploadStatistic(param)
    .done((data) => {
      setStatistic(data);
    })
    .fail((ret, msg) => {
      alert(msg);
    });
  }, [queryAccountId, actionSubTypes]);
  const handleLeadsTypeChange = (e, value) => {
    setLeadsType(value);
  };
  const handleChangeSubaccount = (value) => {
    setQueryAccountId(value);
  };
  const onClickGoToUploadSetting = () => {
    location.href = "#/analysis/rule";
  };
  const averageLast14LeadsNum = trendData.leadsTrendData.average || 0;
  return (
    <main className="main" id="analysis-upload">
      <SubAccountSelector onChange={handleChangeSubaccount}/>
      <div className="card padding-normal no-margin">
        <div className="card-title">
          <span className="left">数据概览</span>
          <div className='overview-tip right'>
            <div className='icon-info-tip' />
            <span className="overview-desc" style={{ marginLeft: '3px' }}>
              当前页面数据统计范围：客户主体粒度下所有归因成功的数据；数据时间范围 {startDate} 至 {endDate}
            </span>
            {/* <SelectTree
              clear
              multiple
              data={leadsTypeTreeForTableFilter}
              value={actionSubTypes}
              onChange={handleLeadsTypeChange}
              placeholder="全部线索类型"
              className="leads-type"
            /> */}
          </div>
        </div>
        {/* 子账号不展示修改上报条件按钮  by fightingliu */}
        {!isSubAccount() && <div className='go-to-upload-setting' onClick={onClickGoToUploadSetting}>修改上报条件 &gt; </div>}
        <div className="total-analysis">
          <OneCard
            cardName="日均线索量"
            popoverStr="近14天内线索量的平均值"
            data={trendData.leadsTrendData}
            height={300}
            width={650}
          ></OneCard>
          <div className="space-divider-10" />
          <OneCard
            cardName="日均上报有效线索量"
            popoverStr="近14天内上报有效线索数的平均值"
            data={trendData.effectiveLeadsReportTrendData}
            height={300}
            width={650}
          ></OneCard>
        </div>
        {averageLast14LeadsNum < 50 && <div className='analysis-result less-than-50'>
          <span className='dot highlight-color' />
          <span className='highlight-color'>最近 14 天日均线索量&lt;50 条</span>
          <span className='normal-color'>不适合投放深层优化目标，请先</span>
          <span className='highlight-color'>提高日均线索量到 &ge;50 条</span>
          <span className='normal-color'>后再考虑投放深层优化目标。</span>
        </div>}
        {averageLast14LeadsNum >= 50 && averageLast14LeadsNum < 200 && <div className='analysis-result more-than-50'>
          <span className='dot highlight-color' />
          <span className='highlight-color'>最近 14 天日均线索量 &ge;50 条</span>
          <span className='normal-color'>可按深度优化目标辅助优化投放。</span>
        </div>}
        {averageLast14LeadsNum >= 200 && <div className='analysis-result more-than-200'>
          <span className='dot highlight-color' />
          <span className='highlight-color'>最近 14 天日均线索量 &ge;200 条</span>
          <span className='normal-color'>可按深度优化目标出价投放或辅助优化投放。</span>
        </div>}
      </div>

      <div className="card padding-normal">

        <div className="card-title">
          <span className="left">深层优化目标投放影响因素</span>
          <div className='overview-tip right'>
            <div className='icon-info-tip' />
            <span className="overview-desc" style={{ marginLeft: '5px' }}>
              当前线索数据：有效综合线索
            </span>
          </div>
        </div>
        <div className='upload-factors'>
          <div className='upload-factor upload-immediate'>
            <div className='upload-factor-title'>上报及时性</div>
            <div className='upload-factor-detail'>
              <div className='upload-item'>
                <div className='upload-item-title'>首日上报率</div>
                <div className='upload-item-number'>{uploadStatistic.reportRate1d ? `${(uploadStatistic.reportRate1d * 100).toFixed(2)}%` : 0}</div>
              </div>
              <div className='upload-item'>
                <div className='upload-item-title'>两日上报率</div>
                <div className='upload-item-number'>{uploadStatistic.reportRate2d ? `${(uploadStatistic.reportRate2d * 100).toFixed(2)}%` : 0}</div>
              </div>
              <div className='upload-item'>
                <div className='upload-item-title'>七日上报率</div>
                <div className='upload-item-number'>{uploadStatistic.reportRate7d ? `${(uploadStatistic.reportRate7d * 100).toFixed(2)}%` : 0}</div>
              </div>
            </div>
            <div className='upload-desc'>线索上报越及时，模型越精准。线索x天内上报率统计逻辑：对14天内[当日上报有效的线索中距离线索生成日期的时间差为(x-1)天的线索数/当日上报有效线索总数]标注率求平均值。</div>
          </div>
          <div className='upload-factor upload-14day'>
            <div className='upload-factor-title'>14天内上报连续性</div>
            <div className='upload-factor-detail'>
              <div className='upload-item'>
                <div className='upload-item-title'>最近连续上报天数</div>
                <div className='upload-item-number'>{uploadStatistic.latestContinuousReportDays || 0}</div>
              </div>
              <div className='upload-item'>
                <div className='upload-item-title'>累计中断上报天数</div>
                <div className='upload-item-number'>{uploadStatistic.noReportDays || 0}</div>
              </div>
            </div>
            <div className='upload-desc'>线索上报越连续，模型越精准。14天内最新连续上报天数统计逻辑：从当天往前倒推14天算对于当天连续上报的天数；累计中断天数计算口径：14天内没上报的天数。</div>
          </div>
        </div>
      </div>
      <div className="card padding-normal">
        <div className="card-title-all">
          <span className="card-title">影响因素说明</span>
        </div>
        <div className="content-step">1、当诊断结果为适合投放深层优化目标时，广告主可进一步关注及时性和连续性来判断模型有效性，上报越及时、越连续，模型越精准。</div>
        <div className="content-step">2、若诊断结果为可按深度优化目标辅助优化投放，建议有效线索七日上报率≥90%。</div>
        <div className="content-step">3、若诊断结果为可按深度优化目标出价投放，建议首日有效线索上报率≥ 60%，两日上报率≥ 80%，且每日连续上报。</div>

      </div>
    </main>
  );
};
